var map = {
	"./001.png": 32173,
	"./002.png": 50550,
	"./003.png": 30527,
	"./004.png": 79200,
	"./005.png": 50377,
	"./006.png": 59666,
	"./007.png": 57531,
	"./008.png": 19724,
	"./009.png": 88821,
	"./010.png": 8655,
	"./011.png": 43462,
	"./012.png": 24669,
	"./013.png": 3540,
	"./014.png": 53451,
	"./015.png": 62946,
	"./016.png": 45881,
	"./017.png": 39632,
	"./018.png": 55991,
	"./019.png": 56494,
	"./020.png": 2430,
	"./021.png": 73767,
	"./022.png": 5292,
	"./023.png": 88181,
	"./024.png": 30234,
	"./025.png": 35459,
	"./026.png": 98600,
	"./027.png": 38545,
	"./028.png": 27062,
	"./029.png": 5151,
	"./030.png": 21177,
	"./031.png": 24272,
	"./032.png": 77771,
	"./033.png": 56642,
	"./034.png": 52989,
	"./035.png": 31860,
	"./036.png": 50767,
	"./037.png": 28102,
	"./038.png": 67905,
	"./039.png": 99640,
	"./040.png": 34824,
	"./041.png": 83217,
	"./042.png": 6970,
	"./043.png": 96803,
	"./044.png": 47404,
	"./045.png": 59029,
	"./046.png": 38654,
	"./047.png": 14439,
	"./048.png": 70208,
	"./049.png": 94409,
	"./050.png": 73491,
	"./051.png": 34634,
	"./052.png": 48865,
	"./053.png": 27736,
	"./054.png": 76727,
	"./055.png": 31150,
	"./056.png": 1509,
	"./057.png": 18620,
	"./058.png": 28107,
	"./059.png": 6978,
	"./060.png": 53282,
	"./061.png": 43787,
	"./062.png": 29968,
	"./063.png": 36217,
	"./064.png": 33798,
	"./065.png": 98991,
	"./066.png": 93876,
	"./067.png": 15005,
	"./068.png": 4234,
	"./069.png": 19795,
	"./070.png": 61165,
	"./071.png": 7268,
	"./072.png": 44127,
	"./073.png": 30838,
	"./074.png": 70921,
	"./075.png": 92800,
	"./076.png": 71131,
	"./077.png": 56306,
	"./078.png": 27157,
	"./079.png": 74892,
	"./080.png": 64508,
	"./081.png": 93925,
	"./082.png": 22126,
	"./083.png": 65143,
	"./084.png": 89976,
	"./085.png": 58241,
	"./086.png": 9258,
	"./087.png": 64467,
	"./088.png": 22196,
	"./089.png": 43325,
	"./090.png": 30119,
	"./091.png": 11806,
	"./092.png": 79157,
	"./093.png": 10060,
	"./094.png": 23875,
	"./095.png": 22650,
	"./096.png": 52817,
	"./097.png": 38600,
	"./098.png": 20863,
	"./099.png": 40886,
	"./100.png": 80965,
	"./101.png": 63452,
	"./102.png": 52183,
	"./103.png": 62190,
	"./104.png": 45281,
	"./105.png": 72568,
	"./106.png": 47059,
	"./107.png": 96298,
	"./108.png": 72893,
	"./109.png": 51764,
	"./110.png": 37338,
	"./111.png": 1443,
	"./112.png": 64584,
	"./113.png": 58449,
	"./114.png": 75358,
	"./115.png": 44199,
	"./116.png": 25196,
	"./117.png": 77461,
	"./118.png": 90258,
	"./119.png": 21435,
	"./120.png": 30827,
	"./121.png": 9698,
	"./122.png": 65785,
	"./123.png": 59536,
	"./124.png": 55407,
	"./125.png": 16390,
	"./126.png": 97597,
	"./127.png": 80916,
	"./128.png": 76211,
	"./129.png": 21002,
	"./130.png": 56576,
	"./131.png": 80777,
	"./132.png": 32594,
	"./133.png": 54139,
	"./134.png": 99332,
	"./135.png": 62573,
	"./136.png": 30806,
	"./137.png": 84607,
	"./138.png": 37544,
	"./139.png": 69585,
	"./140.png": 12785,
	"./141.png": 98568,
	"./142.png": 83843,
	"./143.png": 82618,
	"./144.png": 22773,
	"./145.png": 53676,
	"./146.png": 73735,
	"./147.png": 71774,
	"./148.png": 681,
	"./149.png": 29504,
	"./150.png": 29782,
	"./151.png": 7871,
	"./152.png": 94308,
	"./153.png": 20461,
	"./154.png": 38898,
	"./155.png": 87899,
	"./156.png": 49216,
	"./157.png": 4041,
	"./158.png": 5150,
	"./159.png": 76487,
	"./160.png": 53863,
	"./161.png": 85022,
	"./162.png": 87125,
	"./163.png": 34860,
	"./164.png": 11107,
	"./165.png": 47002,
	"./166.png": 68113,
	"./167.png": 74248,
	"./168.png": 4095,
	"./169.png": 90806,
	"./170.png": 82364,
	"./171.png": 18277,
	"./172.png": 6798,
	"./173.png": 6295,
	"./174.png": 84152,
	"./175.png": 5281,
	"./176.png": 47850,
	"./177.png": 79763,
	"./178.png": 53844,
	"./179.png": 74973,
	"./180.png": 72237,
	"./181.png": 8996,
	"./182.png": 94271,
	"./183.png": 40470,
	"./184.png": 90441,
	"./185.png": 66240,
	"./186.png": 63803,
	"./187.png": 42258,
	"./188.png": 71413,
	"./189.png": 59788,
	"./190.png": 89762,
	"./191.png": 53419,
	"./192.png": 88016,
	"./193.png": 3769,
	"./194.png": 15142,
	"./195.png": 83887,
	"./196.png": 61428,
	"./197.png": 82557,
	"./198.png": 5962,
	"./199.png": 56723,
	"./200.png": 72902,
	"./201.png": 41647,
	"./201_10.png": 47755,
	"./201_11.png": 26626,
	"./201_12.png": 91161,
	"./201_13.png": 94256,
	"./201_14.png": 20751,
	"./201_15.png": 98086,
	"./201_16.png": 22973,
	"./201_17.png": 1844,
	"./201_18.png": 44115,
	"./201_19.png": 88906,
	"./201_2.png": 69800,
	"./201_20.png": 76954,
	"./201_21.png": 66787,
	"./201_22.png": 4808,
	"./201_23.png": 53201,
	"./201_24.png": 8638,
	"./201_25.png": 84423,
	"./201_26.png": 17388,
	"./201_27.png": 29013,
	"./201_3.png": 9745,
	"./201_4.png": 57278,
	"./201_5.png": 44967,
	"./201_6.png": 76492,
	"./201_7.png": 59381,
	"./201_8.png": 7378,
	"./201_9.png": 56379,
	"./202.png": 19188,
	"./203.png": 40317,
	"./204.png": 47522,
	"./205.png": 11179,
	"./206.png": 45776,
	"./207.png": 61529,
	"./208.png": 45966,
	"./209.png": 19607,
	"./210.png": 66593,
	"./211.png": 45464,
	"./212.png": 91219,
	"./213.png": 36010,
	"./214.png": 19237,
	"./215.png": 36348,
	"./216.png": 94455,
	"./217.png": 48878,
	"./218.png": 80793,
	"./219.png": 74544,
	"./220.png": 23020,
	"./221.png": 5909,
	"./222.png": 20158,
	"./223.png": 91495,
	"./224.png": 16328,
	"./225.png": 56273,
	"./226.png": 31610,
	"./227.png": 53187,
	"./228.png": 9316,
	"./229.png": 35469,
	"./230.png": 92535,
	"./231.png": 49518,
	"./232.png": 21317,
	"./233.png": 91900,
	"./234.png": 91859,
	"./235.png": 36650,
	"./236.png": 85633,
	"./237.png": 1016,
	"./238.png": 68495,
	"./239.png": 29478,
	"./240.png": 26986,
	"./241.png": 82195,
	"./242.png": 91352,
	"./243.png": 75969,
	"./244.png": 39854,
	"./245.png": 82871,
	"./246.png": 82236,
	"./247.png": 11653,
	"./248.png": 64706,
	"./249.png": 85835,
	"./250.png": 96885,
	"./251.png": 11436,
	"./252.png": 47847,
	"./253.png": 29534,
	"./254.png": 70545,
	"./255.png": 56328,
	"./256.png": 41603,
	"./257.png": 40378,
	"./258.png": 23885,
	"./259.png": 83940,
	"./260.png": 47696,
	"./261.png": 53945,
	"./262.png": 71010,
	"./263.png": 61515,
	"./264.png": 11604,
	"./265.png": 32733,
	"./266.png": 51526,
	"./267.png": 16719,
	"./268.png": 41912,
	"./269.png": 63041,
	"./270.png": 88859,
	"./271.png": 57682,
	"./272.png": 88649,
	"./273.png": 10528,
	"./274.png": 61855,
	"./275.png": 48566,
	"./276.png": 62541,
	"./277.png": 8644,
	"./278.png": 68867,
	"./279.png": 4762,
	"./280.png": 58542,
	"./281.png": 4119,
	"./282.png": 46012,
	"./283.png": 28901,
	"./284.png": 45674,
	"./285.png": 883,
	"./286.png": 55128,
	"./287.png": 76257,
	"./288.png": 41062,
	"./289.png": 80079,
	"./290.png": 28713,
	"./291.png": 73888,
	"./292.png": 28923,
	"./293.png": 63570,
	"./294.png": 45133,
	"./295.png": 18980,
	"./296.png": 32543,
	"./297.png": 54454,
	"./298.png": 65937,
	"./299.png": 25992,
	"./300.png": 99591,
	"./301.png": 23806,
	"./302.png": 44181,
	"./303.png": 32556,
	"./304.png": 81955,
	"./305.png": 92122,
	"./306.png": 68369,
	"./307.png": 19976,
	"./308.png": 67039,
	"./309.png": 29590,
	"./310.png": 45884,
	"./311.png": 63397,
	"./312.png": 60974,
	"./313.png": 34615,
	"./314.png": 55000,
	"./315.png": 27713,
	"./316.png": 78730,
	"./317.png": 29491,
	"./318.png": 34196,
	"./319.png": 55325,
	"./320.png": 40881,
	"./321.png": 47016,
	"./322.png": 83875,
	"./323.png": 19770,
	"./324.png": 59893,
	"./325.png": 7628,
	"./326.png": 26631,
	"./327.png": 74142,
	"./328.png": 3657,
	"./329.png": 25536,
	"./330.png": 9686,
	"./331.png": 6015,
	"./332.png": 51364,
	"./333.png": 7661,
	"./334.png": 35154,
	"./335.png": 33019,
	"./336.png": 54688,
	"./337.png": 25865,
	"./338.png": 96958,
	"./339.png": 15271,
	"./340.png": 53259,
	"./341.png": 32130,
	"./342.png": 96665,
	"./343.png": 99760,
	"./344.png": 26255,
	"./345.png": 3590,
	"./346.png": 28477,
	"./347.png": 7348,
	"./348.png": 49619,
	"./349.png": 94410,
	"./350.png": 21984,
	"./351.png": 76809,
	"./352.png": 11666,
	"./353.png": 77019,
	"./354.png": 67076,
	"./355.png": 93229,
	"./356.png": 2550,
	"./357.png": 80639,
	"./358.png": 74088,
	"./359.png": 14033,
	"./360.png": 76997,
	"./361.png": 94108,
	"./362.png": 52215,
	"./363.png": 6638,
	"./364.png": 24353,
	"./365.png": 3224,
	"./366.png": 48979,
	"./367.png": 93770,
	"./368.png": 86717,
	"./369.png": 53684,
	"./370.png": 82458,
	"./371.png": 72291,
	"./372.png": 10312,
	"./373.png": 58705,
	"./374.png": 14142,
	"./375.png": 89927,
	"./376.png": 22892,
	"./377.png": 34517,
	"./378.png": 5362,
	"./379.png": 26907,
	"./380.png": 47503,
	"./381.png": 8486,
	"./382.png": 6045,
	"./383.png": 73012,
	"./384.png": 22923,
	"./385.png": 1794,
	"./386.png": 57881,
	"./386_0.png": 71856,
	"./386_1.png": 68761,
	"./386_2.png": 20578,
	"./386_3.png": 41707,
	"./387.png": 51632,
	"./388.png": 71543,
	"./389.png": 25966,
	"./390.png": 91428,
	"./391.png": 54669,
	"./392.png": 39254,
	"./393.png": 76703,
	"./394.png": 65024,
	"./395.png": 89225,
	"./396.png": 24690,
	"./397.png": 46235,
	"./398.png": 42220,
	"./399.png": 53845,
	"./400.png": 60096,
	"./401.png": 14921,
	"./402.png": 49778,
	"./403.png": 15131,
	"./404.png": 5188,
	"./405.png": 31341,
	"./406.png": 40662,
	"./407.png": 18751,
	"./408.png": 12200,
	"./409.png": 52145,
	"./410.png": 91371,
	"./411.png": 70242,
	"./412.png": 34777,
	"./412_2.png": 67138,
	"./413.png": 37872,
	"./413_2.png": 65667,
	"./414.png": 80719,
	"./415.png": 41702,
	"./416.png": 66589,
	"./417.png": 45460,
	"./418.png": 87731,
	"./419.png": 32522,
	"./420.png": 20570,
	"./421.png": 10403,
	"./422.png": 48424,
	"./423.png": 96817,
	"./424.png": 52254,
	"./425.png": 28039,
	"./426.png": 61004,
	"./427.png": 72629,
	"./428.png": 43474,
	"./429.png": 65019,
	"./430.png": 15109,
	"./431.png": 32220,
	"./432.png": 90327,
	"./433.png": 44750,
	"./434.png": 62465,
	"./435.png": 41336,
	"./436.png": 87091,
	"./437.png": 48234,
	"./438.png": 24829,
	"./439.png": 91796,
	"./440.png": 83996,
	"./441.png": 23890,
	"./442.png": 99086,
	"./443.png": 72727,
	"./444.png": 93112,
	"./445.png": 65825,
	"./446.png": 16842,
	"./447.png": 67603,
	"./448.png": 72308,
	"./449.png": 93437,
	"./450.png": 37703,
	"./451.png": 61918,
	"./452.png": 82293,
	"./453.png": 70668,
	"./454.png": 20067,
	"./455.png": 7853,
	"./456.png": 6481,
	"./457.png": 58088,
	"./458.png": 21503,
	"./459.png": 67702,
	"./460.png": 64150,
	"./461.png": 66508,
	"./462.png": 89476,
	"./463.png": 45773,
	"./464.png": 73266,
	"./465.png": 93512,
	"./466.png": 70419,
	"./467.png": 63977,
	"./468.png": 35070,
	"./469.png": 53383,
	"./470.png": 78993,
	"./471.png": 85128,
	"./472.png": 21987,
	"./473.png": 74234,
	"./474.png": 98005,
	"./475.png": 45740,
	"./476.png": 64743,
	"./477.png": 12254,
	"./478.png": 41769,
	"./479.png": 63648,
	"./479_2.png": 88307,
	"./479_3.png": 37546,
	"./479_4.png": 22213,
	"./479_5.png": 4700,
	"./480.png": 19112,
	"./481.png": 33329,
	"./482.png": 3162,
	"./483.png": 4387,
	"./484.png": 90572,
	"./485.png": 59669,
	"./486.png": 92318,
	"./487.png": 10631,
	"./488.png": 50048,
	"./489.png": 21225,
	"./490.png": 307,
	"./491.png": 84746,
	"./492.png": 25825,
	"./493.png": 4696,
	"./493_10.png": 66818,
	"./493_11.png": 57323,
	"./493_12.png": 43504,
	"./493_13.png": 49753,
	"./493_14.png": 47334,
	"./493_15.png": 12527,
	"./493_16.png": 7412,
	"./493_17.png": 28541,
	"./493_2.png": 75963,
	"./493_3.png": 61138,
	"./493_4.png": 65997,
	"./493_5.png": 12100,
	"./493_6.png": 48959,
	"./493_7.png": 52022,
	"./493_8.png": 29329,
	"./493_9.png": 96731,
	"./494.png": 26839,
	"./Shiny/001s.png": 65374,
	"./Shiny/002s.png": 71179,
	"./Shiny/003s.png": 73216,
	"./Shiny/004s.png": 53309,
	"./Shiny/005s.png": 45450,
	"./Shiny/006s.png": 35111,
	"./Shiny/007s.png": 97116,
	"./Shiny/008s.png": 30793,
	"./Shiny/009s.png": 66406,
	"./Shiny/010s.png": 69776,
	"./Shiny/011s.png": 86459,
	"./Shiny/012s.png": 62158,
	"./Shiny/013s.png": 68145,
	"./Shiny/014s.png": 18700,
	"./Shiny/015s.png": 90135,
	"./Shiny/016s.png": 71962,
	"./Shiny/017s.png": 70349,
	"./Shiny/018s.png": 95480,
	"./Shiny/019s.png": 64547,
	"./Shiny/020s.png": 63715,
	"./Shiny/021s.png": 64024,
	"./Shiny/022s.png": 72057,
	"./Shiny/023s.png": 52406,
	"./Shiny/024s.png": 16895,
	"./Shiny/025s.png": 13204,
	"./Shiny/026s.png": 66997,
	"./Shiny/027s.png": 12386,
	"./Shiny/028s.png": 859,
	"./Shiny/029s.png": 97200,
	"./Shiny/030s.png": 62450,
	"./Shiny/031s.png": 22725,
	"./Shiny/032s.png": 19716,
	"./Shiny/033s.png": 27791,
	"./Shiny/034s.png": 710,
	"./Shiny/035s.png": 90057,
	"./Shiny/036s.png": 44136,
	"./Shiny/037s.png": 19027,
	"./Shiny/038s.png": 28394,
	"./Shiny/039s.png": 99517,
	"./Shiny/040s.png": 14629,
	"./Shiny/041s.png": 65650,
	"./Shiny/042s.png": 37487,
	"./Shiny/043s.png": 62596,
	"./Shiny/044s.png": 11081,
	"./Shiny/045s.png": 4166,
	"./Shiny/046s.png": 73811,
	"./Shiny/047s.png": 47944,
	"./Shiny/048s.png": 42397,
	"./Shiny/049s.png": 38090,
	"./Shiny/050s.png": 75092,
	"./Shiny/051s.png": 78783,
	"./Shiny/052s.png": 74274,
	"./Shiny/053s.png": 28885,
	"./Shiny/054s.png": 25912,
	"./Shiny/055s.png": 25603,
	"./Shiny/056s.png": 14294,
	"./Shiny/057s.png": 33945,
	"./Shiny/058s.png": 34636,
	"./Shiny/059s.png": 36695,
	"./Shiny/060s.png": 45127,
	"./Shiny/061s.png": 49308,
	"./Shiny/062s.png": 2941,
	"./Shiny/063s.png": 40618,
	"./Shiny/064s.png": 72395,
	"./Shiny/065s.png": 73824,
	"./Shiny/066s.png": 69889,
	"./Shiny/067s.png": 23454,
	"./Shiny/068s.png": 93039,
	"./Shiny/069s.png": 31940,
	"./Shiny/070s.png": 42550,
	"./Shiny/071s.png": 5849,
	"./Shiny/072s.png": 2584,
	"./Shiny/073s.png": 97507,
	"./Shiny/074s.png": 82242,
	"./Shiny/075s.png": 91765,
	"./Shiny/076s.png": 73172,
	"./Shiny/077s.png": 56735,
	"./Shiny/078s.png": 64270,
	"./Shiny/079s.png": 17777,
	"./Shiny/080s.png": 28169,
	"./Shiny/081s.png": 38822,
	"./Shiny/082s.png": 57139,
	"./Shiny/083s.png": 82248,
	"./Shiny/084s.png": 60837,
	"./Shiny/085s.png": 562,
	"./Shiny/086s.png": 65903,
	"./Shiny/087s.png": 57828,
	"./Shiny/088s.png": 92897,
	"./Shiny/089s.png": 72638,
	"./Shiny/090s.png": 37272,
	"./Shiny/091s.png": 23395,
	"./Shiny/092s.png": 49206,
	"./Shiny/093s.png": 19833,
	"./Shiny/094s.png": 56532,
	"./Shiny/095s.png": 56223,
	"./Shiny/096s.png": 58050,
	"./Shiny/097s.png": 26453,
	"./Shiny/098s.png": 44976,
	"./Shiny/099s.png": 62875,
	"./Shiny/100s.png": 76006,
	"./Shiny/101s.png": 40393,
	"./Shiny/102s.png": 15432,
	"./Shiny/103s.png": 24947,
	"./Shiny/104s.png": 16786,
	"./Shiny/105s.png": 35141,
	"./Shiny/106s.png": 52260,
	"./Shiny/107s.png": 43503,
	"./Shiny/108s.png": 74974,
	"./Shiny/109s.png": 78881,
	"./Shiny/110s.png": 55287,
	"./Shiny/111s.png": 83852,
	"./Shiny/112s.png": 96973,
	"./Shiny/113s.png": 85530,
	"./Shiny/114s.png": 27,
	"./Shiny/115s.png": 65776,
	"./Shiny/116s.png": 7441,
	"./Shiny/117s.png": 57934,
	"./Shiny/118s.png": 93375,
	"./Shiny/119s.png": 93684,
	"./Shiny/120s.png": 41540,
	"./Shiny/121s.png": 2639,
	"./Shiny/122s.png": 79826,
	"./Shiny/123s.png": 28197,
	"./Shiny/124s.png": 69064,
	"./Shiny/125s.png": 90931,
	"./Shiny/126s.png": 25638,
	"./Shiny/127s.png": 41609,
	"./Shiny/128s.png": 58908,
	"./Shiny/129s.png": 54727,
	"./Shiny/130s.png": 49173,
	"./Shiny/131s.png": 91234,
	"./Shiny/132s.png": 65119,
	"./Shiny/133s.png": 21780,
	"./Shiny/134s.png": 54457,
	"./Shiny/135s.png": 65430,
	"./Shiny/136s.png": 57795,
	"./Shiny/137s.png": 88728,
	"./Shiny/138s.png": 79949,
	"./Shiny/139s.png": 81562,
	"./Shiny/140s.png": 29954,
	"./Shiny/141s.png": 39477,
	"./Shiny/142s.png": 4532,
	"./Shiny/143s.png": 4447,
	"./Shiny/144s.png": 90262,
	"./Shiny/145s.png": 37209,
	"./Shiny/146s.png": 50296,
	"./Shiny/147s.png": 28867,
	"./Shiny/148s.png": 73306,
	"./Shiny/149s.png": 53901,
	"./Shiny/150s.png": 29043,
	"./Shiny/151s.png": 7176,
	"./Shiny/152s.png": 79721,
	"./Shiny/153s.png": 63750,
	"./Shiny/154s.png": 40751,
	"./Shiny/155s.png": 79652,
	"./Shiny/156s.png": 66309,
	"./Shiny/157s.png": 17938,
	"./Shiny/158s.png": 20107,
	"./Shiny/159s.png": 21536,
	"./Shiny/160s.png": 33760,
	"./Shiny/161s.png": 4587,
	"./Shiny/162s.png": 9790,
	"./Shiny/163s.png": 13697,
	"./Shiny/164s.png": 16796,
	"./Shiny/165s.png": 8167,
	"./Shiny/166s.png": 87306,
	"./Shiny/167s.png": 74781,
	"./Shiny/168s.png": 19400,
	"./Shiny/169s.png": 94291,
	"./Shiny/170s.png": 57809,
	"./Shiny/171s.png": 5742,
	"./Shiny/172s.png": 76123,
	"./Shiny/173s.png": 56112,
	"./Shiny/174s.png": 64013,
	"./Shiny/175s.png": 92474,
	"./Shiny/176s.png": 33719,
	"./Shiny/177s.png": 48012,
	"./Shiny/178s.png": 47321,
	"./Shiny/179s.png": 11318,
	"./Shiny/180s.png": 96046,
	"./Shiny/181s.png": 45553,
	"./Shiny/182s.png": 3888,
	"./Shiny/183s.png": 38139,
	"./Shiny/184s.png": 23642,
	"./Shiny/185s.png": 35085,
	"./Shiny/186s.png": 21964,
	"./Shiny/187s.png": 93399,
	"./Shiny/188s.png": 24470,
	"./Shiny/189s.png": 95097,
	"./Shiny/190s.png": 64607,
	"./Shiny/191s.png": 44564,
	"./Shiny/192s.png": 14709,
	"./Shiny/193s.png": 60098,
	"./Shiny/194s.png": 11427,
	"./Shiny/195s.png": 11736,
	"./Shiny/196s.png": 19769,
	"./Shiny/197s.png": 83766,
	"./Shiny/198s.png": 22519,
	"./Shiny/199s.png": 20460,
	"./Shiny/200s.png": 49627,
	"./Shiny/201s.png": 55024,
	"./Shiny/201s_10.png": 5562,
	"./Shiny/201s_11.png": 23139,
	"./Shiny/201s_12.png": 21512,
	"./Shiny/201s_13.png": 35729,
	"./Shiny/201s_14.png": 94718,
	"./Shiny/201s_15.png": 13031,
	"./Shiny/201s_16.png": 92972,
	"./Shiny/201s_17.png": 62069,
	"./Shiny/201s_18.png": 32914,
	"./Shiny/201s_19.png": 30779,
	"./Shiny/201s_2.png": 74019,
	"./Shiny/201s_20.png": 76363,
	"./Shiny/201s_21.png": 12706,
	"./Shiny/201s_22.png": 26713,
	"./Shiny/201s_23.png": 10960,
	"./Shiny/201s_24.png": 23183,
	"./Shiny/201s_25.png": 38086,
	"./Shiny/201s_26.png": 21853,
	"./Shiny/201s_27.png": 84372,
	"./Shiny/201s_3.png": 26266,
	"./Shiny/201s_4.png": 50037,
	"./Shiny/201s_5.png": 97772,
	"./Shiny/201s_6.png": 16775,
	"./Shiny/201s_7.png": 64286,
	"./Shiny/201s_8.png": 93801,
	"./Shiny/201s_9.png": 15680,
	"./Shiny/202s.png": 27537,
	"./Shiny/203s.png": 74030,
	"./Shiny/204s.png": 59031,
	"./Shiny/205s.png": 3948,
	"./Shiny/206s.png": 15949,
	"./Shiny/207s.png": 35354,
	"./Shiny/208s.png": 90915,
	"./Shiny/209s.png": 12344,
	"./Shiny/210s.png": 25469,
	"./Shiny/211s.png": 52157,
	"./Shiny/212s.png": 60988,
	"./Shiny/213s.png": 3335,
	"./Shiny/214s.png": 82270,
	"./Shiny/215s.png": 45057,
	"./Shiny/216s.png": 79616,
	"./Shiny/217s.png": 30603,
	"./Shiny/218s.png": 59058,
	"./Shiny/219s.png": 24389,
	"./Shiny/220s.png": 43705,
	"./Shiny/221s.png": 7702,
	"./Shiny/222s.png": 35363,
	"./Shiny/223s.png": 35672,
	"./Shiny/224s.png": 22293,
	"./Shiny/225s.png": 84034,
	"./Shiny/226s.png": 88543,
	"./Shiny/227s.png": 68500,
	"./Shiny/228s.png": 54193,
	"./Shiny/229s.png": 18478,
	"./Shiny/230s.png": 15784,
	"./Shiny/231s.png": 90675,
	"./Shiny/232s.png": 72358,
	"./Shiny/233s.png": 61705,
	"./Shiny/234s.png": 91364,
	"./Shiny/235s.png": 99439,
	"./Shiny/236s.png": 34098,
	"./Shiny/237s.png": 78021,
	"./Shiny/238s.png": 30144,
	"./Shiny/239s.png": 971,
	"./Shiny/240s.png": 89759,
	"./Shiny/241s.png": 90068,
	"./Shiny/242s.png": 59989,
	"./Shiny/243s.png": 91586,
	"./Shiny/244s.png": 40579,
	"./Shiny/245s.png": 54456,
	"./Shiny/246s.png": 53369,
	"./Shiny/247s.png": 82742,
	"./Shiny/248s.png": 51671,
	"./Shiny/249s.png": 80236,
	"./Shiny/250s.png": 33806,
	"./Shiny/251s.png": 23441,
	"./Shiny/252s.png": 41424,
	"./Shiny/253s.png": 41755,
	"./Shiny/254s.png": 43610,
	"./Shiny/255s.png": 41997,
	"./Shiny/256s.png": 90348,
	"./Shiny/257s.png": 61783,
	"./Shiny/258s.png": 27478,
	"./Shiny/259s.png": 16505,
	"./Shiny/260s.png": 74589,
	"./Shiny/261s.png": 95914,
	"./Shiny/262s.png": 39156,
	"./Shiny/263s.png": 20956,
	"./Shiny/264s.png": 41537,
	"./Shiny/265s.png": 95102,
	"./Shiny/266s.png": 44043,
	"./Shiny/267s.png": 45472,
	"./Shiny/268s.png": 90245,
	"./Shiny/269s.png": 41874,
	"./Shiny/270s.png": 65836,
	"./Shiny/271s.png": 20919,
	"./Shiny/272s.png": 97242,
	"./Shiny/273s.png": 77837,
	"./Shiny/274s.png": 16912,
	"./Shiny/275s.png": 11515,
	"./Shiny/276s.png": 35918,
	"./Shiny/277s.png": 89425,
	"./Shiny/278s.png": 28468,
	"./Shiny/279s.png": 28383,
	"./Shiny/280s.png": 45459,
	"./Shiny/281s.png": 19592,
	"./Shiny/282s.png": 82729,
	"./Shiny/283s.png": 75814,
	"./Shiny/284s.png": 9135,
	"./Shiny/285s.png": 34244,
	"./Shiny/286s.png": 86277,
	"./Shiny/287s.png": 20946,
	"./Shiny/288s.png": 76139,
	"./Shiny/289s.png": 25152,
	"./Shiny/290s.png": 29570,
	"./Shiny/291s.png": 84181,
	"./Shiny/292s.png": 30388,
	"./Shiny/293s.png": 50431,
	"./Shiny/294s.png": 69590,
	"./Shiny/295s.png": 5593,
	"./Shiny/296s.png": 97560,
	"./Shiny/297s.png": 97251,
	"./Shiny/298s.png": 50746,
	"./Shiny/299s.png": 22285,
	"./Shiny/300s.png": 93432,
	"./Shiny/301s.png": 88355,
	"./Shiny/302s.png": 33398,
	"./Shiny/303s.png": 96697,
	"./Shiny/304s.png": 64020,
	"./Shiny/305s.png": 63935,
	"./Shiny/306s.png": 73090,
	"./Shiny/307s.png": 98965,
	"./Shiny/308s.png": 36112,
	"./Shiny/309s.png": 47067,
	"./Shiny/310s.png": 39209,
	"./Shiny/311s.png": 6886,
	"./Shiny/312s.png": 72179,
	"./Shiny/313s.png": 66664,
	"./Shiny/314s.png": 25797,
	"./Shiny/315s.png": 77426,
	"./Shiny/316s.png": 239,
	"./Shiny/317s.png": 22788,
	"./Shiny/318s.png": 77089,
	"./Shiny/319s.png": 14302,
	"./Shiny/320s.png": 62810,
	"./Shiny/321s.png": 61197,
	"./Shiny/322s.png": 25900,
	"./Shiny/323s.png": 80983,
	"./Shiny/324s.png": 53006,
	"./Shiny/325s.png": 58993,
	"./Shiny/326s.png": 76976,
	"./Shiny/327s.png": 77307,
	"./Shiny/328s.png": 72482,
	"./Shiny/329s.png": 46773,
	"./Shiny/330s.png": 62027,
	"./Shiny/331s.png": 64064,
	"./Shiny/332s.png": 76481,
	"./Shiny/333s.png": 56222,
	"./Shiny/334s.png": 42311,
	"./Shiny/335s.png": 4316,
	"./Shiny/336s.png": 44157,
	"./Shiny/337s.png": 52650,
	"./Shiny/338s.png": 22547,
	"./Shiny/339s.png": 96680,
	"./Shiny/340s.png": 66204,
	"./Shiny/341s.png": 4199,
	"./Shiny/342s.png": 98186,
	"./Shiny/343s.png": 28426,
	"./Shiny/344s.png": 25952,
	"./Shiny/345s.png": 23915,
	"./Shiny/346s.png": 18110,
	"./Shiny/347s.png": 38369,
	"./Shiny/348s.png": 11748,
	"./Shiny/349s.png": 86639,
	"./Shiny/350s.png": 40109,
	"./Shiny/351s.png": 45018,
	"./Shiny/352s.png": 98423,
	"./Shiny/353s.png": 43340,
	"./Shiny/354s.png": 66929,
	"./Shiny/355s.png": 17422,
	"./Shiny/356s.png": 43163,
	"./Shiny/357s.png": 25264,
	"./Shiny/358s.png": 6741,
	"./Shiny/359s.png": 54690,
	"./Shiny/360s.png": 52926,
	"./Shiny/361s.png": 73185,
	"./Shiny/362s.png": 76896,
	"./Shiny/363s.png": 64075,
	"./Shiny/364s.png": 46794,
	"./Shiny/365s.png": 17917,
	"./Shiny/366s.png": 59932,
	"./Shiny/367s.png": 51303,
	"./Shiny/368s.png": 19110,
	"./Shiny/369s.png": 8457,
	"./Shiny/370s.png": 28335,
	"./Shiny/371s.png": 53444,
	"./Shiny/372s.png": 5477,
	"./Shiny/373s.png": 56498,
	"./Shiny/374s.png": 64659,
	"./Shiny/375s.png": 55144,
	"./Shiny/376s.png": 18281,
	"./Shiny/377s.png": 11366,
	"./Shiny/378s.png": 6804,
	"./Shiny/379s.png": 42076,
	"./Shiny/380s.png": 77488,
	"./Shiny/381s.png": 81147,
	"./Shiny/382s.png": 27118,
	"./Shiny/383s.png": 62833,
	"./Shiny/384s.png": 53036,
	"./Shiny/385s.png": 55095,
	"./Shiny/386s.png": 97498,
	"./Shiny/386s_2.png": 65557,
	"./Shiny/386s_3.png": 29644,
	"./Shiny/387s.png": 69037,
	"./Shiny/388s.png": 44312,
	"./Shiny/389s.png": 44003,
	"./Shiny/390s.png": 53697,
	"./Shiny/391s.png": 7262,
	"./Shiny/392s.png": 39243,
	"./Shiny/393s.png": 88256,
	"./Shiny/394s.png": 60797,
	"./Shiny/395s.png": 56490,
	"./Shiny/396s.png": 11975,
	"./Shiny/397s.png": 69628,
	"./Shiny/398s.png": 45833,
	"./Shiny/399s.png": 38918,
	"./Shiny/400s.png": 8509,
	"./Shiny/401s.png": 4202,
	"./Shiny/402s.png": 59687,
	"./Shiny/403s.png": 17340,
	"./Shiny/404s.png": 1409,
	"./Shiny/405s.png": 38622,
	"./Shiny/406s.png": 86955,
	"./Shiny/407s.png": 35968,
	"./Shiny/408s.png": 80741,
	"./Shiny/409s.png": 31762,
	"./Shiny/410s.png": 748,
	"./Shiny/411s.png": 2807,
	"./Shiny/412s.png": 45210,
	"./Shiny/412s_2.png": 70293,
	"./Shiny/413s.png": 16749,
	"./Shiny/413s_2.png": 98750,
	"./Shiny/414s.png": 8848,
	"./Shiny/415s.png": 28859,
	"./Shiny/416s.png": 74830,
	"./Shiny/417s.png": 10545,
	"./Shiny/418s.png": 24852,
	"./Shiny/419s.png": 44895,
	"./Shiny/420s.png": 55967,
	"./Shiny/421s.png": 28980,
	"./Shiny/422s.png": 56373,
	"./Shiny/423s.png": 82082,
	"./Shiny/424s.png": 64995,
	"./Shiny/425s.png": 95928,
	"./Shiny/426s.png": 61657,
	"./Shiny/427s.png": 56278,
	"./Shiny/428s.png": 90583,
	"./Shiny/429s.png": 19148,
	"./Shiny/430s.png": 30382,
	"./Shiny/431s.png": 83889,
	"./Shiny/432s.png": 11376,
	"./Shiny/433s.png": 22331,
	"./Shiny/434s.png": 91706,
	"./Shiny/435s.png": 88653,
	"./Shiny/436s.png": 60300,
	"./Shiny/437s.png": 15383,
	"./Shiny/438s.png": 8662,
	"./Shiny/439s.png": 71961,
	"./Shiny/440s.png": 47833,
	"./Shiny/441s.png": 77206,
	"./Shiny/442s.png": 51395,
	"./Shiny/443s.png": 48920,
	"./Shiny/444s.png": 54453,
	"./Shiny/445s.png": 86050,
	"./Shiny/446s.png": 84223,
	"./Shiny/447s.png": 84532,
	"./Shiny/448s.png": 14641,
	"./Shiny/449s.png": 48782,
	"./Shiny/450s.png": 6280,
	"./Shiny/451s.png": 15795,
	"./Shiny/452s.png": 66854,
	"./Shiny/453s.png": 31241,
	"./Shiny/454s.png": 59460,
	"./Shiny/455s.png": 34351,
	"./Shiny/456s.png": 7634,
	"./Shiny/457s.png": 25989,
	"./Shiny/458s.png": 73664,
	"./Shiny/459s.png": 71627,
	"./Shiny/460s.png": 66971,
	"./Shiny/461s.png": 63312,
	"./Shiny/462s.png": 48657,
	"./Shiny/463s.png": 12942,
	"./Shiny/464s.png": 40919,
	"./Shiny/465s.png": 38860,
	"./Shiny/466s.png": 54861,
	"./Shiny/467s.png": 83322,
	"./Shiny/468s.png": 29827,
	"./Shiny/469s.png": 30136,
	"./Shiny/470s.png": 94506,
	"./Shiny/471s.png": 65629,
	"./Shiny/472s.png": 7644,
	"./Shiny/473s.png": 99015,
	"./Shiny/474s.png": 638,
	"./Shiny/475s.png": 20897,
	"./Shiny/476s.png": 24608,
	"./Shiny/477s.png": 95435,
	"./Shiny/478s.png": 28562,
	"./Shiny/479s.png": 72485,
	"./Shiny/479s_2.png": 82214,
	"./Shiny/479s_3.png": 21231,
	"./Shiny/479s_4.png": 78384,
	"./Shiny/479s_5.png": 75289,
	"./Shiny/480s.png": 56885,
	"./Shiny/481s.png": 2274,
	"./Shiny/482s.png": 6783,
	"./Shiny/483s.png": 86740,
	"./Shiny/484s.png": 61945,
	"./Shiny/485s.png": 25942,
	"./Shiny/486s.png": 53603,
	"./Shiny/487s.png": 53912,
	"./Shiny/488s.png": 78637,
	"./Shiny/489s.png": 7098,
	"./Shiny/490s.png": 9604,
	"./Shiny/491s.png": 17679,
	"./Shiny/492s.png": 52338,
	"./Shiny/493s_10.png": 97161,
	"./Shiny/493s_11.png": 42336,
	"./Shiny/493s_12.png": 4315,
	"./Shiny/493s_13.png": 6450,
	"./Shiny/493s_14.png": 78957,
	"./Shiny/493s_15.png": 39012,
	"./Shiny/493s_16.png": 93663,
	"./Shiny/493s_17.png": 97334,
	"./Shiny/493s_2.png": 52870,
	"./Shiny/493s_3.png": 91887,
	"./Shiny/493s_4.png": 49040,
	"./Shiny/493s_5.png": 45945,
	"./Shiny/493s_6.png": 97762,
	"./Shiny/493s_7.png": 18891,
	"./Shiny/493s_8.png": 15292,
	"./Shiny/493s_9.png": 44709,
	"./Shiny/494s.png": 34024,
	"./characters/Red.png": 76222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76324;